<template>
  <div>
    <Modal @closeModal="$emit('closeTriggered')">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <span class="font-weight-bold">SHARE POST</span>
      </div>

      <!-- MODAL BODY -->
      <div slot="modal-body">
        <form action @submit.prevent>
          <div class="share-post-modal">
            <div class="form-group">
              <label
                for="comment"
                class="font-weight-bold color_grey_dark font-14 mt-3"
                >Copy the URL below to share this post</label
              >
              <input
                type="text"
                v-model="post_url"
                ref="posturlinput"
                class="form-control mt-2"
              />
            </div>
          </div>

          <!-- CANCEL OR SUBMIT FORM -->
          <div
            class="modal-body-row row mb-0 d-flex flex-center"
            style="margin-bottom: -40px"
          >
            <button
              type="submit"
              class="btn btn-md btn-accent"
              ref="copyBtn"
              @click="copyLink"
            >
              Copy Link
            </button>
          </div>
        </form>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/globalComps/Modal";
import { APP_BASE_URL } from "@/var";

export default {
  name: "SharePostModal",

  props: ["token", "path"],

  components: {
    Modal,
  },

  data() {
    return {
      post_url: "",
    };
  },

  mounted() {
    if (this.path) this.post_url = APP_BASE_URL + "/account-post/" + this.path;
    else this.post_url = APP_BASE_URL + "/account-post/" + this.token;
  },

  methods: {
    copyLink() {
      let url_input = this.$refs.posturlinput;
      url_input.value = this.post_url;

      url_input.focus();
      url_input.select();
      url_input.setSelectionRange(0, 99999); /*For mobile devices*/

      document.execCommand("copy");

      this.$refs.copyBtn.innerHTML =
        '<div class="icon-accept font-18 mr-2"></div>Link Copied';

      setTimeout(() => {
        this.$refs.copyBtn.innerHTML = "Copy Link";
      }, 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
.share-post-modal {
  margin-top: -20px;
  padding: auto 0 !important;

  label {
    @include breakpoint_max(sm) {
      font-size: 12px !important;
      font-weight: 500 !important;
    }
  }
}
</style>
